export enum PflegiaForFriendsMailType {
  CvBonus = 'cv_bonus',
  HiringBonus = 'hiring_bonus',
  InvalidCv = 'invalid_cv',
}
